
import React, { useCallback } from "react";
import RegularButton from "components/CustomButtons/Button";
import { useToggle } from "hooks/useToggle";
import { useDispatch } from "react-redux";
import { ModalV2 } from "components/Modal/ModalV2";
import { blue, red } from "@mui/material/colors";
import EditIcon from '@mui/icons-material/Edit';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { ChangePassForm } from "./ChangePassForm";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { selectUser } from "redux/actions/users/usersActions";
import BackspaceIcon from '@mui/icons-material/Backspace';
import { DeleteUserForm } from "./DeleteUserForm";

export const columns = [
    {
        "Header": "Usuario",
        "accessor": "username",
        "filterable": true,
        "filterMethod": (filter, row) => row.username.toLowerCase().includes(filter.value.toLowerCase())
    },
    {
        "Header": "Nombre",
        "accessor": "name",
        "filterable": true,
        "filterMethod": (filter, row) => row.name.toLowerCase().includes(filter.value.toLowerCase())
    },
    {
        "Header": "Correo electrónico",
        "accessor": "email",
        "filterable": true,
        "filterMethod": (filter, row) => row.email.toLowerCase().includes(filter.value.toLowerCase())
    },
    {
        "Header": "Acciones",
        Cell: ({ original }) => {
            const dispatch = useDispatch()
            const hist = useHistory()
            const [isDelete, setIsDelete] = useToggle()
            const [passModal, setPassModal] = useToggle()

            const handleNav = useCallback(() => {
                hist.push(`/admin/usuario_detalles/${original.id}`)
                dispatch(selectUser({ ...original }))
            }, [original.id])
            return (
                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 4
                }}>
                    <RegularButton
                        tooltip="Editar usuario"
                        round
                        justIcon
                        color="transparent"
                        size="sm"
                        onClick={handleNav}>
                        <EditIcon style={{ color: blue[500] }} />
                    </RegularButton>
                    <RegularButton
                        tooltip="Cambiar contraseña"
                        round
                        justIcon
                        color="transparent"
                        size="sm"
                        onClick={setPassModal}>
                        <VpnKeyIcon style={{ color: blue[500] }} />
                    </RegularButton>
                    <RegularButton
                        tooltip={`Eliminar usuario ${original.username}`}
                        round
                        justIcon
                        color="transparent"
                        size="sm"
                        onClick={setIsDelete}>
                        <BackspaceIcon style={{ color: red[500] }} />
                    </RegularButton>
                    <ModalV2
                        open={isDelete}
                        onClose={setIsDelete}
                        title={`Seguro que desea realizar esta acción?`}
                        toRight
                        justConfirm
                    >
                        <DeleteUserForm data={original} onClose={setIsDelete} />
                    </ModalV2>
                    <ModalV2
                        open={passModal}
                        onClose={setPassModal}
                        title='Cambiar contraseña'
                        justConfirm
                        toRight
                    >
                        <ChangePassForm id={original.id} onClose={setPassModal} />
                    </ModalV2>

                </div>
            )
        }
    }
];
